import {UserPermission} from '@/abilities/ability';
import {httpClient} from '@/api/baseApi';
import store from '@/store';
import {VuexModule, Mutation, Action, Module, getModule} from 'vuex-module-decorators';
import router from '@/router';

/*
    Модуль хранилища vuex для работы с токеном авторизации
*/
const moduleName = 'authModule';

@Module({
  name: moduleName,
  store: store,
  dynamic: true,
  namespaced: true,
})
class AuthModule extends VuexModule {
  /* Токен авторизации */
  accessToken = localStorage.getItem('accessToken');

  loggedInUser = localStorage.getItem('loggedInUser');

  previousRoute = localStorage.getItem('previousRoute');

  permissions = localStorage.getItem('permissions');

  /*
    Мутация на установку значения токена авторизации
  */
  @Mutation
  setAccessTokenMutation(state: string) {
    this.accessToken = state;
    localStorage.setItem('accessToken', state);
  }

  @Mutation
  setLoggedInUserMutation(state: string) {
    this.loggedInUser = state;
    localStorage.setItem('loggedInUser', state);
  }

  @Mutation
  setPreviousRouteMutation(state: string | null) {
    this.previousRoute = state;
    if (state) localStorage.setItem('previousRoute', state);
    else localStorage.removeItem('previousRoute');
  }

  @Mutation
  setPermissionsMutation(state: UserPermission[]) {
    const permissions = JSON.stringify(state);
    this.permissions = permissions;
    if (state) localStorage.setItem('permissions', permissions);
    else localStorage.removeItem('permissions');
  }

  /*
    Мутация на сброс всего модуля
  */
  @Mutation
  clearMutation() {
    this.accessToken = null;
    this.loggedInUser = null;
    localStorage.removeItem('accessToken');
    localStorage.removeItem('loggedInUser');
  }

  /*
    Действие на установку токена
  */
  @Action
  setAccessToken(state: string) {
    this.context.commit('setAccessTokenMutation', state);
  }

  @Action
  setLoggedInUser(state: string) {
    this.context.commit('setLoggedInUserMutation', state);
  }

  @Action
  setPreviousRoute(state: string | null) {
    this.context.commit('setPreviousRouteMutation', state);
  }

  @Action
  setPermissions(state: UserPermission[]) {
    this.context.commit('setPermissionsMutation', state);
  }

  /*
    Действия на сброс всего модуля
  */
  @Action
  clear() {
    this.context.commit('clearMutation');
  }

  get getAccessToken() {
    return this.accessToken;
  }

  get getLoggedInUser() {
    return this.loggedInUser;
  }

  get getPreviousRoute() {
    return this.previousRoute;
  }

  get getPermissions(): UserPermission[] {
    if (this.permissions) return JSON.parse(this.permissions);
    return [];
  }

  @Action
  async logout(previousRoute: any = null) {
    try {
      await httpClient.post(`logout`);
      this.clear();
      this.setPreviousRoute(previousRoute);
      router.push('/login');
    } catch (e) {
      return Promise.reject(e);
    }
  }
}

export default getModule(AuthModule);
